import React from 'react';

const showPurchase = () => (
  <div className="section-container">
    <div className="section-general">
      Show Purchase
    </div>
  </div>
);

export default showPurchase;
